export default __webpack_public_path__ + "static/media/icon-crop.e466e40f.svg";